import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export interface Link {
    linkId: number;
    name: string;
    description: string;
    url: string;
    enabled: boolean;
}

export interface PostLinkData {
    name: string;
    description: string;
    url: string;
    enabled: boolean;
}

export interface UpdateLinkData {
    linkId: number;
    name: string;
    description: string;
    url: string;
    enabled: boolean;
}

// Get all links
export const getLinks = async (): Promise<Link[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/link`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    return response.data;
};

// Get single link by ID
export const getLink = async (linkId: number): Promise<Link> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/link/${linkId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    return response.data;
};

// Create new link
export const createLink = async (linkData: PostLinkData): Promise<Link> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.post(
        `https://${apiURL}/link`,
        linkData,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    );

    return response.data;
};

// Update existing link
export const updateLink = async (linkId: number, linkData: UpdateLinkData): Promise<Link> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.put(
        `https://${apiURL}/link/${linkId}`,
        linkData,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    );

    return response.data;
};

// Delete link
export const deleteLink = async (linkId: number): Promise<void> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    await axios.delete(`https://${apiURL}/link/${linkId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });
};
